<template>
  <b-card>
    <h4 class="mb-3">{{ $t("pages.home.hi", { name: userName }) }} 👋</h4>
    <p class="mb-0">
      {{ $t("pages.home.welcomeText") }}
    </p>
  </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue";

export default {
  components: {
    BCard,
  },
  computed: {
    userName() {
      const userData = JSON.parse(
        localStorage.getItem("foravilaProvidersUserData")
      );
      return userData?.firstName || userData?.fullName || null;
    },
  },
};
</script>
